import Odometer from "odometer";
export function initCountUp() {
  document.querySelectorAll('[data-from][data-to]').forEach(countItem => {
    const countingNumber = new Odometer({
      el: countItem,
      value: Number(countItem.getAttribute('data-from'))
    })

    new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) countingNumber.update(Number(countItem.getAttribute('data-to')));
      })
    }, {
      rootMargin: '96px 0px -25% 0px'
    }).observe(countItem);

  })
}
